import React from 'react';
import PropTypes from 'prop-types';
import { useValidation } from '@glu/validation-react';

const SecurityQuestionsProvider = ({ children, initialData, initialErrors }) => {
  const [FormContextProvider, formContext, { data: values }] = useValidation({
    initialData,
    ...(initialErrors ? { initialErrors } : []),
  });
  return (
    <FormContextProvider value={formContext}>
      {children({ values, formContext })}
    </FormContextProvider>
  );
};

SecurityQuestionsProvider.propTypes = {
  children: PropTypes.func.isRequired,
  initialData: PropTypes.shape({}).isRequired,
  initialErrors: PropTypes.shape({}),
};

SecurityQuestionsProvider.defaultProps = {
  initialErrors: undefined,
};

export default SecurityQuestionsProvider;
